module.exports = __webpack_public_path__ + "img/icon_wancheng.2051da7e.png";